import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const PdfViewerWrapper = styled("div")<{
  height?: number | string;
  width?: number | string;
  marginTop?: number;
}>(({ height, width, marginTop }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  boxSizing: "border-box",
  height: height || 450,
  overflow: "auto",
  padding: 48,
  backgroundColor: colors.gray200,
  marginTop: marginTop || 0,
  width: width || "100%",
  maxWidth: "100%",
}));

/** Vertical stack of all PDF pages for scroll-through viewing */
export const PdfPagesStack = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 24,
  width: "100%",
  minHeight: "min-content",
});

export const PdfViewerFooter = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 4,
  background: colors.gray50,
  borderBottom: `1px solid ${colors.gray300}`,

  "& div.empty-div": {
    width: 100,
  },

  "& div.viewer-buttons": {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
});

export const PdfLoadingWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "100%",
});

export const PdfViewerTitle = styled("span")({
  fontFamily: "Manrope",
  fontSize: 18,
  fontWeight: 700,
  color: colors.gray600,
});

export const PdfViewerLoading = styled("div")({
  marginTop: 16,
  padding: 16,
  border: `1px solid ${colors.gray200}`,
  borderRadius: 6,
  "& > span": {
    color: colors.gray500,
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "21px",
  },
});
